import styled from 'styled-components';

export const AlertPreferencesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
`;

export const NotificationsContainer = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.sm}px;
  display: flex;
  flex-direction: column;
`;

export const NotificationsActions = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.md}px;
  align-items: center;
  justify-content: space-between;
`;

export const NotificationsBody = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  gap: 0;
`;

export const AlertsContainer = styled.section`
  background: ${({ theme }) => theme.colors.white_1};
  border: thin solid ${({ theme }) => theme.colors.grey_5};
  border-radius: ${({ theme }) => theme.border_radius.md};
  overflow: hidden;
  width: 100%;
`;

export const AlertsHeader = styled.header`
  align-items: flex-start;
  display: flex;
  gap: ${({ theme }) => theme.spacing.lg}px;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.xl}px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    flex-direction: column;
    padding: ${({ theme }) => theme.spacing.lg}px;
  }
`;

export const AlertsHeaderCopy = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  min-width: 0;
`;

export const AlertsDescription = styled.div`
  color: ${({ theme }) => theme.colors.grey_2};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
  max-width: ${({ theme }) => theme.caps.xs}px;
`;

export const AlertActions = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: ${({ theme }) => theme.spacing.sm}px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    justify-content: flex-end;
    width: 100%;
  }
`;

export const AlertFilters = styled.div`
  border-top: thin solid ${({ theme }) => theme.colors.grey_5};
  display: flex;
  gap: ${({ theme }) => theme.spacing.md}px;
  padding: ${({ theme }) => `${theme.spacing.lg}px ${theme.spacing.xl}px`};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    padding: ${({ theme }) => theme.spacing.lg}px;
  }
`;

export const AlertFilterControl = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
  max-width: ${({ theme }) => theme.caps.xxs}px;
  width: 100%;
`;

export const AlertList = styled.div`
  border-top: thin solid ${({ theme }) => theme.colors.grey_5};
  display: flex;
  flex-direction: column;
`;

export const AlertRow = styled.article`
  align-items: flex-start;
  background: ${({ theme }) => theme.colors.white_1};
  border-bottom: thin solid ${({ theme }) => theme.colors.grey_5};
  display: grid;
  gap: ${({ theme }) => theme.spacing.md}px;
  grid-template-columns: minmax(0, 1fr) auto;
  padding: ${({ theme }) => `${theme.spacing.lg}px ${theme.spacing.xl}px`};

  &:hover {
    background: ${({ theme }) => theme.colors.beige_3};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    gap: ${({ theme }) => theme.spacing.sm}px;
    grid-template-columns: minmax(0, 1fr);
    padding: ${({ theme }) => theme.spacing.lg}px;
  }
`;

export const AlertContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
  min-width: 0;
`;

export const AlertTitle = styled.span`
  color: ${({ theme }) => theme.colors.grey_1};
  font-size: ${({ theme }) => theme.fonts.body1};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  line-height: ${({ theme }) => theme.fontsLineHeights.body1};
`;

export const AlertBody = styled.span`
  color: ${({ theme }) => theme.colors.grey_2};
  font-size: ${({ theme }) => theme.fonts.body2};
  line-height: ${({ theme }) => theme.fontsLineHeights.body2};
`;

export const AlertDate = styled.time`
  color: ${({ theme }) => theme.colors.grey_3};
  font-size: ${({ theme }) => theme.fonts.body3};
  line-height: ${({ theme }) => theme.fontsLineHeights.body3};
  white-space: nowrap;
`;

export const AlertsLoading = styled.div`
  align-items: center;
  border-top: thin solid ${({ theme }) => theme.colors.grey_5};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  justify-content: center;
  min-height: ${({ theme }) => theme.spacing.xxxxl * 2}px;
  padding: ${({ theme }) => theme.spacing.xxl}px;
  text-align: center;
`;

export const AlertPagination = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding: ${({ theme }) => `${theme.spacing.lg}px ${theme.spacing.xl}px`};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    padding: ${({ theme }) => theme.spacing.lg}px;
  }
`;

export const AlertsSettingsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg}px;
`;

export const ProfilePreferencesSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
`;

export const ProfilePreferencesHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;

export const ProfilePreferencesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
`;

export const ProfilePreferenceCard = styled.article`
  overflow: hidden;
  border: thin solid ${({ theme }) => theme.colors.grey_4};
  border-radius: ${({ theme }) => theme.border_radius.card};
  background: ${({ theme }) => theme.colors.white_1};
`;

export const ProfilePreferenceCardHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
  padding: ${({ theme }) => theme.spacing.md}px;
`;

export const ProfilePreferenceRows = styled.div`
  display: flex;
  flex-direction: column;
  border-top: thin solid ${({ theme }) => theme.colors.grey_4};
`;

export const ProfilePreferenceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.lg}px;
  padding: ${({ theme }) => theme.spacing.md}px;
  border-bottom: thin solid ${({ theme }) => theme.colors.grey_5};

  &:last-of-type {
    border-bottom: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    align-items: flex-start;
  }
`;

export const ProfilePreferenceCopy = styled.div`
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;

export const ProfilePreferenceError = styled.div`
  padding: ${({ theme }) => theme.spacing.md}px;
`;

export const ProfilePreferencesState = styled.div`
  display: flex;
  min-height: ${({ theme }) => theme.spacing.xxxl}px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  padding: ${({ theme }) => theme.spacing.lg}px;
  text-align: center;
`;
